import { render, staticRenderFns } from "./FormRulePreview.vue?vue&type=template&id=aff74178&scoped=true&"
import script from "./FormRulePreview.ts?vue&type=script&lang=ts&"
export * from "./FormRulePreview.ts?vue&type=script&lang=ts&"
import style0 from "./FormRulePreview.scss?vue&type=style&index=0&id=aff74178&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff74178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
